import {
    PERITADOR_GET_VERIFICATION_PDF_BEGIN,
    PERITADOR_GET_VERIFICATION_PDF_SUCCESS,
    PERITADOR_GET_VERIFICATION_PDF_FAILURE,
    PERITADOR_GET_VERIFICATION_PDF_DISMISS_ERROR,
  } from './constants'
  import  { BFFAgent } from "../../../common/BFFAgent.js"
  
  export function getVerificationPdf(requestId, verificationStatusId, isForClient = false, webSignConfigVerificationForClientPDF = null) {
    return async (dispatch) => {
      dispatch({
        type: PERITADOR_GET_VERIFICATION_PDF_BEGIN,
      })      
      const request = await BFFAgent.Peritador.getVerificationPdf(requestId, verificationStatusId, isForClient, webSignConfigVerificationForClientPDF)
      if(request){
        dispatch({
          type: PERITADOR_GET_VERIFICATION_PDF_SUCCESS,
        })
      } else {
        dispatch({
          type: PERITADOR_GET_VERIFICATION_PDF_FAILURE,
        })
      }
      return true
    }
  }
  

  export function dismissGetVerificationPdfError() {
    return {
      type: PERITADOR_GET_VERIFICATION_PDF_DISMISS_ERROR,
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PERITADOR_GET_VERIFICATION_PDF_BEGIN:
        return {
          ...state,
          actGetPdfPending: true,
          actGetPdfError: null,
        }
  
      case PERITADOR_GET_VERIFICATION_PDF_SUCCESS:
        return {
          ...state,
          actGetPdfPending: false,
          actGetPdfError: null,
        }
  
      case PERITADOR_GET_VERIFICATION_PDF_FAILURE:
        return {
          ...state,
          actGetPdfPending: false,
          actGetPdfError: true,
        }
  
      case PERITADOR_GET_VERIFICATION_PDF_DISMISS_ERROR:
        return {
          ...state,
          actGetPdfError: false,
        }
  
      default:
        return state
    }
  }
  
